__turbopack_context__.v({
  "component": "style-module-scss-module__wtpO-W__component",
  "header": "style-module-scss-module__wtpO-W__header",
  "infoIconContainer": "style-module-scss-module__wtpO-W__infoIconContainer",
  "lastUpdated": "style-module-scss-module__wtpO-W__lastUpdated",
  "period": "style-module-scss-module__wtpO-W__period",
  "title": "style-module-scss-module__wtpO-W__title",
  "tooltip": "style-module-scss-module__wtpO-W__tooltip",
  "tooltipArrow": "style-module-scss-module__wtpO-W__tooltipArrow",
  "tooltipContent": "style-module-scss-module__wtpO-W__tooltipContent",
  "unavailable": "style-module-scss-module__wtpO-W__unavailable",
  "value": "style-module-scss-module__wtpO-W__value",
});
